export {AntiAliasType}					from "./text/AntiAliasType";
export {Font}							from "./text/Font";
export {GridFitType}					from "./text/GridFitType";
export {IFontTable}				        from "./text/IFontTable";
export {TesselatedFontTable}			from "./text/TesselatedFontTable";
export {BitmapFontTable}			    from "./text/BitmapFontTable";
export {TesselatedFontChar}				from "./text/TesselatedFontChar";
export {BitmapFontChar}				    from "./text/BitmapFontChar";
export {TextFieldAutoSize}				from "./text/TextFieldAutoSize";
export {TextFieldType}					from "./text/TextFieldType";
export {TextFormat}						from "./text/TextFormat";
export {TextFormatAlign}				from "./text/TextFormatAlign";
export {TextInteractionMode}			from "./text/TextInteractionMode";
export {TextLineMetrics}				from "./text/TextLineMetrics";